module.exports = __webpack_public_path__ + "static/img/banner.1e37a5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/mobile/banner.png
// module id = VuFP
// module chunks = 6